import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=298c8d79&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=298c8d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../ymoffers/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298c8d79",
  null
  
)

export default component.exports